var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { pickBy, includes, get, compact } from 'lodash';
import { classNames } from '@shapeable/utils';
import { ImageEntityBackgroundSlideshow } from '../entities/image-entity-background-slideshow';
import { ColorInfoProvider } from '../context/color-info-context';
import { ThemeModeProvider } from '../context/theme-mode-context';
import { sliceColorInfo } from '../utils/slice-color-info';
import { useComponentProps } from '../context/component-props-context';
import { EllipsisButton } from '../elements/ellipsis-button';
var cls = classNames('slice-layout');
export var SliceLayoutDefaultBoundaryWidths = {
  "none": 0,
  "padding": 0,
  "content-bleed": 1088,
  "content": 1088,
  "content-single": 948,
  "feature": 1280,
  "explorer": 1440,
  "explorer-bleed": 1440
};
export var SliceLayoutUnitPaddingBase = {
  'none': 0,
  'content': 3,
  'slim': 2,
  'small': 4,
  'medium': 5,
  'large': 6
};
export var SliceLayoutUnitPaddingTablet = {
  'none': 0,
  'slim': 3,
  'content': 5,
  'small': 5,
  'medium': 8,
  'large': 10
};
export var SliceLayoutUnitPaddingDesktop = {
  'none': 0,
  'slim': 3,
  'content': 6,
  'small': 8,
  'medium': 16,
  'large': 20
};
export var SliceLayoutDefaultProps = {
  variant: 'default',
  boundary: 'content',
  boundaryWidths: SliceLayoutDefaultBoundaryWidths,
  verticalBalanceDelta: 3,
  showSlideControls: true,
  showMenu: 'never',
  verticalPadding: 'none',
  useBackgroundImages: true,
  useEntityColors: false,
  useAutoOverlay: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    ", ";\n  "], ["\n    ", "\n    ", ";\n  "])), function (_a) {
    var useThemeModeBackground = _a.useThemeModeBackground;
    return useThemeModeBackground && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme.COLOR('canvas'));
  }, theme.APPLY_COLORS)
});
export var SliceLayoutContentPaddingStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4)),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(5), theme.UNIT(5)),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(6), theme.UNIT(6))
});
var BoundaryStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    line-height: 1.5em; \n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    line-height: 1.5em; \n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), theme.APPLY_COLORS, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      max-width: ", "px;\n      margin: 0 auto;\n    "], ["\n      max-width: ", "px;\n      margin: 0 auto;\n    "])), maxWidth);
  }, function (_a) {
    var verticalPadding = _a.verticalPadding,
      verticalBalanceDelta = _a.verticalBalanceDelta;
    return verticalPadding !== 'none' && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "], ["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "])), theme.UNIT(SliceLayoutUnitPaddingBase[verticalPadding]), theme.UNIT(SliceLayoutUnitPaddingBase[verticalPadding], verticalBalanceDelta * 4));
  }, function (_a) {
    var usePadding = _a.usePadding;
    return usePadding && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), SliceLayoutContentPaddingStyles);
  }),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var verticalPadding = _a.verticalPadding,
      verticalBalanceDelta = _a.verticalBalanceDelta;
    return verticalPadding !== 'none' && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "], ["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "])), theme.UNIT(SliceLayoutUnitPaddingTablet[verticalPadding]), theme.UNIT(SliceLayoutUnitPaddingTablet[verticalPadding], verticalBalanceDelta * 4));
  }),
  desktop: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\n    ", "\n  "], ["\n\n    ", "\n  "])), function (_a) {
    var verticalPadding = _a.verticalPadding,
      verticalBalanceDelta = _a.verticalBalanceDelta;
    return verticalPadding !== 'none' && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "], ["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "])), theme.UNIT(SliceLayoutUnitPaddingDesktop[verticalPadding]), theme.UNIT(SliceLayoutUnitPaddingDesktop[verticalPadding], verticalBalanceDelta * 4));
  })
});
var MenuButtonStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ControlsWrapStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    height: 0;\n    z-index: 200;\n    width: 100%;\n    font-size: 0;\n    position: relative;\n  "], ["\n    height: 0;\n    z-index: 200;\n    width: 100%;\n    font-size: 0;\n    position: relative;\n  "])))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    font-size: ", ";\n    position: absolute;\n    right: ", ";\n    top: ", ";\n  "], ["\n    font-size: ", ";\n    position: absolute;\n    right: ", ";\n    top: ", ";\n  "])), theme.FONT_SIZE(16), theme.UNIT(8), theme.UNIT(2))
});
var MenuContainerStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    position: absolute;\n    top: ", ";\n    left: 0;\n  "], ["\n    position: absolute;\n    top: ", ";\n    left: 0;\n  "])), theme.UNIT(14))
});
// -------- Components -------->
var My = {
  Name: 'SliceLayout',
  ControlsWrap: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ControlsWrapStyles),
  Controls: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  MenuButton: styled(EllipsisButton)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  MenuContainer: styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), MenuContainerStyles),
  Container: styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Slideshow: styled(ImageEntityBackgroundSlideshow)(templateObject_23 || (templateObject_23 = __makeTemplateObject([""], [""]))),
  Boundary: styled.div.attrs(cls.attr('boundary'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), BoundaryStyles)
};
export var SliceLayout = React.forwardRef(function (argProps, ref) {
  var props = useComponentProps(My.Name, SliceLayoutDefaultProps, argProps);
  var variant = props.variant,
    className = props.className,
    children = props.children,
    _a = props.entity,
    entity = _a === void 0 ? {} : _a,
    boundary = props.boundary,
    boundaryWidths = props.boundaryWidths,
    verticalPadding = props.verticalPadding,
    verticalBalanceDelta = props.verticalBalanceDelta,
    aspectRatio = props.aspectRatio,
    useThemeModeBackground = props.useThemeModeBackground,
    showMenu = props.showMenu,
    menuButtonTitle = props.menuButtonTitle,
    showSlideControls = props.showSlideControls,
    fadeColor = props.fadeColor,
    overlayColor = props.overlayColor,
    onMenuButtonClick = props.onMenuButtonClick,
    MenuComponent = props.menuComponent,
    slideControls = props.slideControls,
    useAutoOverlay = props.useAutoOverlay,
    autoOverlayMaxOpacity = props.autoOverlayMaxOpacity;
  var _b = __read(React.useState(false), 2),
    isMenuVisible = _b[0],
    setIsMenuVisible = _b[1];
  var _c = __read(React.useState(false), 2),
    isMenuButtonVisible = _c[0],
    setIsMenuButtonVisible = _c[1];
  var colorInfo = sliceColorInfo(entity);
  var color = colorInfo.color,
    backgroundColor = colorInfo.backgroundColor;
  var _d = entity.backgroundImages,
    backgroundImages = _d === void 0 ? [] : _d,
    backgroundImage = entity.backgroundImage;
  var usePadding = includes(['content', 'padding', 'content-single', 'explorer'], boundary);
  var maxWidth = !includes(['none', 'padding'], boundary) && boundaryWidths[boundary];
  var sizingOnly = includes(['boundary', 'boundary', 'vertical'], variant);
  var useBackgroundImages = props.useBackgroundImages && !sizingOnly;
  var useColors = props.useEntityColors && !sizingOnly;
  var inner = React.createElement(My.Boundary, {
    verticalBalanceDelta: verticalBalanceDelta,
    verticalPadding: verticalPadding,
    usePadding: usePadding,
    maxWidth: maxWidth
  }, children);
  var buttonRef = useRef();
  var layoutSlug = get(entity, 'layout.slug', '');
  var sliceLayoutClass = !!layoutSlug && "".concat(cls.prf("slice-layout-".concat(layoutSlug)));
  var resolvedBackgroundImages = backgroundImages.length ? backgroundImages : compact([backgroundImage]);
  var ellipsisButtonOnClick = onMenuButtonClick && function (event) {
    return onMenuButtonClick(event, entity);
  } || function () {
    return setIsMenuVisible(!isMenuVisible);
  };
  var menu = MenuComponent && React.createElement(MenuComponent, {
    entity: entity,
    ref: buttonRef
  });
  var hasMenu = showMenu !== 'never' && (!!onMenuButtonClick || !!menu);
  return React.createElement(ColorInfoProvider, {
    value: colorInfo
  }, hasMenu && React.createElement(My.ControlsWrap, null, React.createElement(My.Controls, null, (showMenu === 'always' || isMenuButtonVisible && showMenu === 'hover') && React.createElement(My.MenuButton, {
    title: menuButtonTitle,
    ref: buttonRef,
    onClick: ellipsisButtonOnClick
  }), !!menu && React.createElement(My.MenuContainer, null, isMenuVisible && menu))), React.createElement(My.Container, {
    onMouseEnter: function () {
      return setIsMenuButtonVisible(true);
    },
    onMouseLeave: function () {
      return setIsMenuButtonVisible(false);
    },
    useThemeModeBackground: useThemeModeBackground,
    ref: ref,
    colors: useColors && {
      background: backgroundColor,
      text: color
    },
    className: "".concat(cls.name(className), " ").concat(sliceLayoutClass)
  }, useBackgroundImages && !!resolvedBackgroundImages.length ? React.createElement(My.Slideshow, {
    useAutoOverlay: useAutoOverlay,
    autoOverlayMaxOpacity: autoOverlayMaxOpacity,
    showInfo: true,
    overlayColor: overlayColor,
    fadeColor: fadeColor,
    showSlideControls: showSlideControls,
    slideControls: slideControls,
    aspectRatio: aspectRatio,
    items: resolvedBackgroundImages
  }, inner) : inner));
});
/* @ts-ignore */
SliceLayout.cls = cls;
export function createSliceLayout(Slice, options) {
  var _a = options || {},
    classNameId = _a.classNameId,
    _b = _a.props,
    props = _b === void 0 ? {} : _b,
    _c = _a.themeMode,
    themeMode = _c === void 0 ? 'auto' : _c,
    defaultBackgroundColor = _a.defaultBackgroundColor,
    defaultColor = _a.defaultColor,
    rest = __rest(_a, ["classNameId", "props", "themeMode", "defaultBackgroundColor", "defaultColor"]);
  var cls = classNameId && classNames(classNameId);
  return function (sliceLayoutProps) {
    var className = sliceLayoutProps.className,
      entity = sliceLayoutProps.entity;
    var layoutSlice = pickBy(__assign({
      backgroundColor: defaultBackgroundColor,
      color: defaultColor
    }, pickBy(entity)));
    var providerThemeMode = get(entity, 'themeMode.slug', get(entity, 'layout.themeMode.slug', themeMode));
    return React.createElement(ThemeModeProvider, {
      value: providerThemeMode
    }, React.createElement(SliceLayout, __assign({}, rest, {
      useThemeModeBackground: true,
      useEntityColors: true,
      showMenu: "always",
      entity: layoutSlice,
      className: cls ? cls.name(className) : className
    }), React.createElement(Slice, __assign({}, props, {
      entity: entity
    }))));
  };
}
;
export var SliceLayoutBoundary = function (props) {
  return React.createElement(SliceLayout, __assign({}, props, {
    variant: "boundary"
  }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;